import { TEST_IDS } from "@/testIdDefinition";

export type AppAlertButton = {
    text: string;
    variant?: "default" | "outline" | "destructive";
    onPress?: () => void | Promise<void>;
    testID?: string;
};

export type AppAlertRequest = {
    title: string;
    message?: string;
    buttons: AppAlertButton[];
};

type AlertListener = (request: AppAlertRequest | null) => void;

let listener: AlertListener | null = null;
let pendingAlert: AppAlertRequest | null = null;

/**
 * Subscribe `AlertDialogHost` to imperative `showAlert` calls.
 * Returns an unsubscribe function.
 */
export function subscribeAlert(listenerNext: AlertListener): () => void {
    listener = listenerNext;
    if (pendingAlert) {
        listenerNext(pendingAlert);
        pendingAlert = null;
    }
    return () => {
        if (listener === listenerNext) {
            listener = null;
        }
    };
}

function presentAlert(request: AppAlertRequest): void {
    if (listener) {
        listener(request);
        return;
    }
    pendingAlert = request;
}

/**
 * Cross-platform alert via the shared AlertDialog UI (`AlertDialogHost`).
 */
export function showAlert(
    title: string,
    message?: string,
    buttons?: AppAlertButton[]
): void {
    presentAlert({
        title,
        message,
        buttons:
            buttons && buttons.length > 0
                ? buttons
                : [
                      {
                          text: "OK",
                          variant: "default",
                          testID: TEST_IDS[TEST_IDS.ALERT_OK_BUTTON],
                      },
                  ],
    });
}
